import { redirect } from 'next/navigation';

import { uiConfig } from '@/config';
import { AUTH_COOKIE } from '@/constants/cookies';
import { cookieManager } from '@/sdk/client/cookieManager';

import { userStore } from '../userStore';

// const COUNTER = 'foxkit_auth_counter';

export const statefulRefreshToken: Foxkit.StatefulRefreshTokenOptions = {
  authCookieName: AUTH_COOKIE,
  authCookieDomain:
    process.env.NODE_ENV !== 'development' &&
    !(typeof window !== 'undefined' && window.location.hostname.includes('dev-ond'))
      ? uiConfig.authCookieDomain
      : undefined,
  onAccessTokenUpdated: (authData?: Foxkit.UserCookie) => {
    userStore.set(authData);
  },
  onRefreshError: (error: { message: string; statusCode: number }) => {
    const { statusCode } = error;

    console.error(`[CentralizedLogin][statefulRefreshTokenOptions][onRefreshError] error ${statusCode}`, error);

    redirect('/logout');

    // TODO commenting it out for now, since it was causing issue: DTCWEB-690
    // let counter = Number(window.sessionStorage.getItem(COUNTER));
    // console.error(`[CentralizedLogin] counter ${counter}`, counter);
    // if (statusCode === 401 && counter < 2) {
    //   window.sessionStorage.setItem(COUNTER, `${++counter}`);
    // } else {
    //   window.sessionStorage.removeItem(COUNTER);
    //   redirect('/logout');
    // }
  },

  cookieManager,
  use: true,
};
